<template>
  <div v-if="subList.length>0">
      <vxe-table
        border
        show-overflow
        ref="xTable"
        :data="subList"
        @checkbox-change="checkboxChange"
        @checkbox-all="checkboxAll"
      >
        <template v-for="config in columns">
          <vxe-table-column
            :key="config.id"
            v-bind="config"
            :min-width="config.minWidth || 150"
          ></vxe-table-column>
        </template>
      </vxe-table>
  </div>
</template>
<script>
import _ from 'xe-utils';
import request from '@/found/utils/request';

export default {
  name: 'edit_details',
  props: {
    subList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [],
    };
  },
  components: {},
  watch: {
    subList() {
      if (this.subList.length > 0) {
        this.getColumns();
      }
    },
  },
  created() {

  },
  methods: {
    // 获取发票表头配置
    async getColumns() {
      const params = {
        parentCode: 'CRM20201127000000116',
        functionCode: 'main_list',
      };
      const res = await request.post('/mdm/mdmtableconfig/query', params);
      if (res.success) {
        this.columns = res.result.column
          .filter((v) => v.visible)
          .map((v) => {
            const rowData = v;
            return rowData;
          });
      }
    },
  },
};
</script>

<style lang="less" scepod>

</style>
